import { useQuery } from "@tanstack/react-query";
import { startChat, startChatIds } from "./chatService";

export function useStartChat({
  searchType,
  proposal_id,
  purpose,
  docIds,
  files = [],
  queryProps = {},
}) {
  return useQuery({
    queryFn: () =>
      Array.isArray(docIds)
        ? startChatIds(searchType, proposal_id, purpose, docIds)
        : startChat(searchType, proposal_id, purpose, files),
    queryKey: [`chatHistory`, purpose, searchType, proposal_id],
    staleTime: 12 * 60 * 60 * 1000, // 12 hours
    refetchOnMount: "always",
    ...queryProps,
  });
}
